<template>
    <div>
        <ModalGlobal id="logoutModal" v-if="modalActivate">
            <template #dialogHeadImg>
                <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/photopass-logo.png')" alt="logo photo" />
            </template>

            <template #dialogHeading>{{
                $t("Forms.title_modal_recover")
                }}</template>

            <template #dialogDescription>{{
                $t("Forms.msg_modal_activate")
                }}</template>

            <router-link :title="$t('Forms.login_account')"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto"
                :to="{ name: 'login' }">{{ $t("Forms.login_account") }}</router-link>

            <button @click="modalActivate = false" :disabled="loading" type="button"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto">
                Continuar navegando
            </button>
        </ModalGlobal>

        <div id="formFolio" class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124">
            <!-- Forgot Form | Recovery Account -->
            <div class="flex flex-col w-full mx-auto">
                <div class="title uppercase text-center font-bold">
                    {{ $t("Forms.activate_user") }}
                </div>
                <p class="mb-3 mt-3">
                    {{ $t("Forms.if_you_have_account") }}
                    <a class="cursor-pointer text-newxcaret-blue" @click.prevent="setModalAuth(1)">
                        {{ $t("Forms.login") }}
                    </a>
                </p>

                <p class="mb-4" v-if="getUser?.Email">
                    <template v-if="!getTimeExpired">
                        <span
                            v-html="$tc('Forms.expiration_time_description', getFormattedMinutes + ':' + getFormattedSeconds)">
                        </span>
                    </template>
                    <template v-else>
                        <span v-html="$tc('Forms.still_received_activation_code', getUser?.Email)"></span>
                        <a style="text-transform: lowercase;" class="cursor-pointer text-newxcaret-blue"
                            @click.prevent="resetTimer(), resendAccessCode()">
                            {{ $t("Forms.forward_it_again") }}.
                        </a>
                    </template>
                </p>

                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(activateNewUser)"
                        class="flex flex-col w-full pt-2 pb-6 relative">
                        <ValidationProvider rules="required|email" v-slot="{ errors }" hidden>
                            <label class="font-bold" :for="$t('Forms.email')">
                                {{ $t("Forms.email") }}
                            </label>
                            <input type="text" placeholder="email@dominio.com" :id="$t('Forms.email')"
                                v-model="formActiveNewUser.Email" :class="[errorLogin.email && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg" />
                            <p class="txt-error text-red text-xs italic mb-4">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                        <p class="text-red text-xs italic" v-if="errorLogin.email" hidden>
                            {{ responseErrors.Email[0] }}
                        </p>

                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <label class="font-bold" for="CodeFor">
                                {{ $t("Forms.code_email") }}
                            </label>
                            <input type="text" id="CodeFor" v-model="formActiveNewUser.Code" :name="$t('Forms.code')"
                                :class="[errorLogin.Code && 'border-newxcaret-red']"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg" />
                            <p class="txt-error text-red text-xs italic mb-4">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                        <p class="text-red text-xs italic" v-if="errorLogin.Code">
                            {{ responseErrors.Code[0] }}
                        </p>

                        <p class="text-red text-xs italic" v-if="msgApi.error">
                            {{ msgApi.message }}
                        </p>

                        <p class="text-red text-xs italic" v-if="msgApi.success">
                            {{ msgApi.message }}
                        </p>

                        <button type="submit"
                            class="flex items-center justify-center w-full mt-4 mt-4 md:mx-2 p-2 bg-yellow-photo rounded-full text-sm font-semibold">
                            {{ $t("Forms.activate_user") }}
                        </button>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@validators/index";
import methodUser from "@mixins/methodUser";

import Users from "@mixins/Users";
import SearchPackage from "@components/photo/searchPackageComponent";
import activateNewUserData from "@logic/profile/activateNewUser";

export default {
    props: [],
    mixins: [methodUser, Users],
    components: {
        SearchPackage
    },
    data: () => ({
        modalActivate: false,
        loading: false,
        formActiveNewUser: {
            Email: "", //example@email.com
            Code: "",
            helperBtnSend: true,
        }
    }),
    watch: {
        activeForm: function () {
            this.errorLogin.statusApiMessage = false;
            this.msgApi.success = false;
            this.msgApi.error = false;
            this.disableAllInputs();
        },
    },
    computed: {
        // Acceder al state de 'auth' module
        ...mapState('auth', ['modalAuth', 'user']),
        ...mapState('timer', ['endTime', 'minutes', 'seconds', 'interval', 'timeExpired']),

        // Usar getters de 'auth' module
        ...mapGetters('auth', ['getModalAuth', 'getUser']),
        ...mapGetters('timer', ['getTimeExpired', 'getMinutes', 'getSeconds', 'getEndTime', 'getFormattedMinutes', 'getFormattedSeconds'])
    },
    methods: {
        // Usar acciones de 'auth' module
        ...mapActions('auth', ['setModalAuth', 'setUser']),
        ...mapActions('timer', ['setTimeExpired', 'setMinutes', 'setSeconds', 'setEndTime']),
        /**
         * Metodo para activar un nuevo usuario
         * @returns {Promise<void>}
         * @throws {Promise<void>}
        */
        async activateNewUser() {
            try {
                this.$store.dispatch("setLoading", true);
                this.errorLogin.statusApiMessage = false;
                // POST request using axios
                let response = await activateNewUserData.create(
                    this.formActiveNewUser
                );

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        () => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    this.errorLogin.Code = false;

                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (response.data.SUCCESS == "true") {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "success",
                                });

                                this.setModalAuth(1);
                            } else {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "error",
                                });
                            }
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
            } catch (error) {
                Vue.$toast.open({
                    message: $t("Forms.try_catch_api"),
                    type: "error",
                });
            } finally {
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
            }
        },
        /**
         * Metodo realizar el conteo regresivo
         * @returns {void}
        */
        updateCountdown() {
            const now = new Date().getTime();
            const distance = this.getEndTime - now;

            if (distance <= 0) {
                // Si el tiempo ha expirado
                clearInterval(this.$store.state.timer.interval);
                this.setTimeExpired(true);
                this.setMinutes(0);
                this.setSeconds(0);
            } else {
                // Calcular los minutos y segundos restantes
                this.setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
                this.setSeconds(Math.floor((distance % (1000 * 60)) / 1000));
            }
        },
        /**
         * Metodo para iniciar el conteo regresivo
         * @returns {void}
         */
        startCountdown() {
            // Crear un intervalo que se actualice cada segundo
            this.$store.state.timer.interval = setInterval(() => {
                this.updateCountdown();
            }, 1000);
        },
        /**
         * Metodo para reestablecer el temporizador
         * @returns {void}
         */
        resetTimer() {
            // Establecer un nuevo tiempo de finalización de 10 minutos desde ahora
            const now = new Date().getTime();
            const newEndTime = now + 1 * 60 * 1000;

            this.setEndTime(newEndTime);
            this.setTimeExpired(false);
            this.startCountdown();
        },
    },
    beforeDestroy() {
        clearInterval(this.$store.state.timer.interval);
    },
    mounted() {
        this.formActiveNewUser.Email = this.getUser?.Email;
        // Si endTime ya está definido, no lo reiniciamos
        if (this.getEndTime) {
            // Verificamos si ya ha expirado el temporizador
            this.updateCountdown();
            if (!this.timeExpired) {
                this.startCountdown();
            }
        } else {
            // Si no hay endTime definido, podemos establecer uno nuevo si es necesario
            this.resetTimer();
        }
    }
};
</script>
